import React from "react";
import { ReleaseStatusCount } from "../../../types";
import { getTotalReleaseStatusCount } from "../../../utils";
import styles from "./summary.module.scss";

type VersionCountDetailsProps = { title: string; count: ReleaseStatusCount };

const VersionCountDetails = ({
  title,
  count,
}: VersionCountDetailsProps): React.JSX.Element => {
  // has to be wrapped in fragment otherwise outer CSS grid will break
  return (
    <>
      <div className={styles["version-label"]}>
        <span className={styles["vertical-line"]} />
        {title} ({getTotalReleaseStatusCount(count).toLocaleString()})
      </div>
      <div className={styles["pass-fail-connection"]} />
      <div className={styles["pass-fail-label"]}>
        Fail {count.fail.toLocaleString()}
      </div>
      <div>&middot;</div>
      <div className={styles["pass-fail-label"]}>
        Pass {count.pass.toLocaleString()}
      </div>
    </>
  );
};

export default VersionCountDetails;
